module.exports = __webpack_public_path__ + "media/images/bem2-4b9c55812878b4f334d7294dc8e97efa.png";